import React, { useEffect, useState } from "react";
import { io } from "socket.io-client";
import axios from "axios";

const socket = io("https://alkebulanfkalertbackend.onrender.com");

const UserChatPage = () => {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const userId = localStorage.getItem("userId") || "guest_" + Date.now();

  // Fetch previous messages
  useEffect(() => {
    const fetchMessages = async () => {
      try {
        const res = await axios.get(
          `https://alkebulanfkalertbackend.onrender.com/api/chat/${userId}`
        );
        setMessages(res.data);
      } catch (err) {
        console.error(err);
      }
    };
    fetchMessages();
  }, [userId]);

  // Listen for admin replies
  useEffect(() => {
    socket.on("agentReply", ({ userId: fromUser, message }) => {
      if (fromUser === userId) {
        setMessages((prev) => [...prev, { sender: "admin", text: message }]);
      }
    });
    return () => socket.off("agentReply");
  }, [userId]);

  const sendMessage = async () => {
    if (!input.trim()) return;

    setMessages((prev) => [...prev, { sender: "me", text: input }]);
    socket.emit("userMessage", { userId, message: input });

    try {
      await axios.post("https://alkebulanfkalertbackend.onrender.com/api/chat", {
        userId,
        sender: "user",
        text: input,
      });
    } catch (err) {
      console.error(err);
    }

    setInput("");
  };

  return (
    <div className="flex flex-col h-screen bg-gray-100">
      <div className="flex-1 overflow-y-auto p-4 space-y-2">
        {messages.map((msg, idx) => (
          <div
            key={idx}
            className={`p-2 rounded-lg max-w-xs ${
              msg.sender === "me"
                ? "bg-blue-500 text-white self-end ml-auto"
                : msg.sender === "admin"
                ? "bg-green-500 text-white"
                : "bg-gray-300"
            }`}
          >
            <strong>{msg.sender === "me" ? "You" : "Admin"}: </strong>
            {msg.text}
          </div>
        ))}
      </div>
      <div className="p-4 border-t bg-white flex">
        <input
          className="flex-1 border rounded-lg px-3 py-2"
          placeholder="Type your message..."
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && sendMessage()}
        />
        <button
          className="ml-2 bg-blue-600 text-white px-4 py-2 rounded-lg"
          onClick={sendMessage}
        >
          Send
        </button>
      </div>
    </div>
  );
};

export default UserChatPage;
